import { PhotoStorage } from './photo.storage';

export class AWSPhotoStorage extends PhotoStorage {
  _t = ['PhotoStorage', 'AWSStorage'];
  Key: string;
  Bucket: string;
  Location: string;
  ETag: string;
}
